module.exports = __webpack_public_path__ + "media/images/emblems/Bremblens-coat_of_arms-68e725dc5ace55d04d0fada4d8291428.svg";